import { TranslationFunction } from 'i18next';
import * as React from 'react';
import { translate } from 'react-i18next';
import AppInsightsService from '../app-insights/service';
import FooterLogoEnCA from '../assets/img/by-bmo-logo.svg';
import FooterLogoFrCA from '../assets/img/by-bmo-logo-fr.svg';
import { LANGUAGE_CODE_EN_CA, SHOW_MAINTENANCE_PAGE } from '../constants';
import { default as i18n, getDocumentTitle } from '../locales';
import {  MIXPANEL_PROPERTY_PAGE_TITLE } from '../mixpanel.service';
import * as AppUtils from '../utils';
import { NavMenu } from './nav-menu';
import { RouterNavLinkProps } from './router-nav-link';

interface SiteFooterComponentProps {
  t: TranslationFunction;
  onClick?: {
    [key: string]: React.MouseEventHandler<HTMLAnchorElement>;
  };
  children?: void;
}

class SiteFooterComponent extends React.PureComponent<SiteFooterComponentProps> {
  constructor(props: SiteFooterComponentProps) {
    super(props);

    this.onNavLinkClick = this.onNavLinkClick.bind(this);
  }

  public render(): React.ReactNode {
    const navMenu = this.props.t('siteFooter.navMenu') as { [key: string]: RouterNavLinkProps };
    const [footerLogoImgSrc, footerLogoImgAlt] =
      i18n.language === LANGUAGE_CODE_EN_CA
        ? [FooterLogoEnCA, SHOW_MAINTENANCE_PAGE() ? 'Brought to you by BMO' : 'Brought to you by BMO, Powered by idassist']
        : [FooterLogoFrCA, SHOW_MAINTENANCE_PAGE() ? 'Présenté par BMO' : 'Présenté par BMO, Fourni par assist identité'];
    Object.keys(navMenu).forEach((key) => {
      const navLinkProps = navMenu[key];
      navLinkProps['data-key'] = key;
      navLinkProps.onClick = this.onNavLinkClick;
    });

    if(SHOW_MAINTENANCE_PAGE()){
      delete navMenu['faq'];
    }

    return (
      <footer className="site-footer">
        <div className="row-logos">
          <div className="col-logos">
            <img src={footerLogoImgSrc} alt={footerLogoImgAlt} height="66" width="118" />
          </div>
        </div>
        <div className="row-nav-menu">
          <div className="col-nav-menu">
            <NavMenu menu={navMenu} />
          </div>
        </div>
      </footer>
    );
  }

  public onNavLinkClick(event: React.MouseEvent<HTMLAnchorElement>): void {
    const elCurrentTarget = event.currentTarget;
    if (elCurrentTarget == null) {
      return;
    }

    //const { onClick: onClickProp } = this.props;
    const key = elCurrentTarget.getAttribute('data-key') as string;
    //const clickHandler = onClickProp && Object.prototype.hasOwnProperty.call(onClickProp, key) && onClickProp[key];
    //const callClickHandler = () => AppUtils.isFunction(clickHandler) && clickHandler(event);

    const eventName = `Click ${AppUtils.jsPropertyNameToTitleCase(key)} Menu Item`;
    this.trackEvent(eventName)
     
  }

  // tslint:disable-next-line:no-any
  private trackEvent(eventName: string, props?: { [key: string]: any }) {
    const pageTitle = getDocumentTitle(window.location.pathname, { lng: LANGUAGE_CODE_EN_CA });
    const properties = Object.assign({}, { [MIXPANEL_PROPERTY_PAGE_TITLE]: pageTitle }, props);
     AppInsightsService.trackEvent({ name: eventName, properties });
    //return MixpanelService.track(eventName, properties);
  }
}

const SiteFooter = translate('global', { i18n })(SiteFooterComponent);
export default SiteFooter;
